module.exports = __webpack_public_path__ + "static/media/3 breakfast.2b63f433.png";